enum StepId {
  EXTRAS = 'EXTRAS',
  TRAVELER_DETAILS = 'TRAVELERDETAILS',
  CONFIRMATION = 'CONFIRMATION'
}

export default StepId;
